import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import React from 'react';
import DropdownButton from './DropdownButton';
import DropdownContent from './DropdownContent';
import '../containers/addressHistory.scss';
const AddressHistoryDropdown = ({ addressHistory, opened, toggleDropdown }) => {
    const spanLightText = content => (_jsx("span", { className: "dropdown__content--item--light", children: content }));
    const dropdown = addressHistory.map(singleAddressHistory => {
        const open = opened === 0 ? addressHistory[0].workOrderId : opened;
        const closeDropdown = open !== singleAddressHistory.workOrderId;
        return (_jsxs("div", { className: "address_history__dropdown", children: [_jsx(DropdownButton, { closeDropdown: closeDropdown, open: open, singleAddressHistory: singleAddressHistory, toggleDropdown: toggleDropdown }), _jsx(DropdownContent, { closeDropdown: closeDropdown, spanLightText: spanLightText, singleAddressHistory: singleAddressHistory })] }, singleAddressHistory.workOrderId));
    });
    return _jsx("div", { className: "dropdown", children: dropdown });
};
AddressHistoryDropdown.propTypes = {
    addressHistory: PropTypes.arrayOf(PropTypes.any).isRequired,
    opened: PropTypes.number.isRequired,
    toggleDropdown: PropTypes.func.isRequired,
};
export default AddressHistoryDropdown;
